/*
 * SammyGift: make Dawn's desktop dropdown menu behave like Minimal's site-nav.
 * - Minimal opens dropdowns (and the "Cakes > Cake Delivery in China > cities" flyout) on hover.
 * - Minimal's parent items are real links (e.g. Cakes -> /collections/cakes); Dawn renders them as <summary>.
 * Only active on hover-capable desktop pointers (>= 990px, where Dawn shows the inline menu).
 * Keyboard (click events with detail === 0) and touch keep Dawn's click-to-open behaviour.
 */
(function () {
  const mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const CLOSE_DELAY = 150;

  function setOpen(details, open) {
    const summary = details.querySelector(':scope > summary');
    if (open) details.setAttribute('open', '');
    else details.removeAttribute('open');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function init() {
    document.querySelectorAll('.header__inline-menu details').forEach((details) => {
      if (details.dataset.sgHover) return;
      details.dataset.sgHover = '1';
      let timer;
      details.addEventListener('mouseenter', () => {
        if (!mq.matches) return;
        clearTimeout(timer);
        // Close sibling top-level menus so only one is open at a time.
        const li = details.closest('li');
        if (li && li.parentElement) {
          li.parentElement.querySelectorAll(':scope > li > header-menu > details[open], :scope > li > details[open]').forEach((d) => {
            if (d !== details) setOpen(d, false);
          });
        }
        setOpen(details, true);
      });
      details.addEventListener('mouseleave', () => {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => setOpen(details, false), CLOSE_DELAY);
      });
      const summary = details.querySelector(':scope > summary[data-sg-href]');
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (!mq.matches || event.detail === 0) return; // keyboard / non-hover devices: Dawn default
          const href = summary.dataset.sgHref;
          if (!href || href === '#') return;
          event.preventDefault();
          window.location.href = href;
        });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
